/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";

import "./Attachment.scss";

const Attachment = ({ document, assetInfo }) => {
	const download = () => {
		window.open(document.Url, "_blank");
	};

	const containsImageExtension = str => {
		const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp"];
		const imageName = (str || "").toLowerCase();
		return imageExtensions.some(ext => imageName.endsWith(ext));
	};

	const isImage = containsImageExtension(document?.SourceFileName);
	const idPdf = /\.(pdf)$/i.test(document?.SourceFileName || "");

	return (
		<div
			className="attachment-asset"
			onClick={download}
		>
			<Choose>
				<When condition={isImage}>
					<div
						className="attachment-asset__preview"
						style={{
							backgroundImage: `url('${document.Url}')`,
						}}
					>
						<span>{document.FileName}</span>
					</div>
				</When>
				<When condition={idPdf}>
					<div className="attachment-asset__preview">
						<embed
							src={document.Url}
							width="100%"
							height="100%"
						/>
					</div>
				</When>
				<Otherwise>
					<div className="attachment-asset__preview">
						<span>{document.FileName}</span>
					</div>
				</Otherwise>
			</Choose>

			<div className="attachment-asset__info">{assetInfo}</div>
		</div>
	);
};

Attachment.propTypes = {
	document: PropTypes.object.isRequired,
	assetInfo: PropTypes.string.isRequired,
};

export default Attachment;
